import { defineAction } from '~/prix'
import { z } from 'zod'
import machineServiceImageConfirmAction from './machineServiceImageConfirm.action.json' with { type: 'json' }
import { machineServiceImageStatus } from '../machineServiceImageObject'

const machineServiceImageConfirmDefinition = defineAction({
  ...machineServiceImageConfirmAction,

  input: z.object({
    id: z.string().uuid(),
    status: machineServiceImageStatus,
  }),
  output: z.object({}),
})

export default machineServiceImageConfirmDefinition
